var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#E7F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1634 46.6464L57.1727 46.6413H57.1546L46.5283 40.8833L35.8844 35.1152L25.24 40.8833L14.6138 46.6413H14.5957L14.605 46.6464L14.5957 46.6515H14.6138L25.24 52.4094L35.8844 58.1775L46.5283 52.4094L57.1546 46.6515H57.1727L57.1634 46.6464Z",
    fill: "#B7E6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1634 24.5312L57.1727 24.5265H57.1546L46.5283 18.7681L35.8844 13L25.24 18.7681L14.6138 24.5265H14.5957L14.605 24.5312L14.5957 24.5362H14.6138L25.24 30.2946L35.8844 36.0627L46.5283 30.2946L57.1546 24.5362H57.1727L57.1634 24.5312Z",
    fill: "#26B5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6133 24.0625V47.1151L35.8839 35.589L14.6133 24.0625Z",
    fill: "#86D6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.155 24.0625V47.1151L35.8848 35.589L57.155 24.0625Z",
    fill: "#86D6F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcons);
export default __webpack_public_path__ + "static/media/pricingIcons.54339cb6f1e4dd544200b936422d350b.svg";
export { ForwardRef as ReactComponent };